import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { StyledListItem, StyledSmartSearchListItem } from '../styles';
import { AssistantSearchListItemProps } from '../hooks/useAssistantSearchResultListMap';
import { AssistantSearchType } from '../../assistantSearchTypes';

interface ListItemProps {
    assistantSearchListItemProps: AssistantSearchListItemProps;
    chatPanelSearch: boolean;
    searchType: AssistantSearchType;
    focused: boolean;
    handleUnFocused: () => void;
}

export const AssistantSearchResultListItem = ({
    assistantSearchListItemProps,
    chatPanelSearch,
    searchType,
    focused,
    handleUnFocused,
    ...others
}: ListItemProps) => {
    const assistantSmartSearchEnabled = useFeatureFlag(FeatureFlag.assistantSmartSearchEnabled);
    const { itemId, value, routeAction, ...props } = assistantSearchListItemProps;
    const dispatch: CommanderThunkDispatch = useDispatch();

    const handleOnClick = useCallback(() => {
        if (routeAction) {
            dispatch(routeAction);
            handleUnFocused();
        }
    }, [dispatch, handleUnFocused, routeAction]);

    return chatPanelSearch && assistantSmartSearchEnabled ? (
        <StyledSmartSearchListItem
            tabIndex={0}
            key={itemId}
            focused={focused}
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleOnClick();
            }}
            {...props}
            {...others}
            shouldScrollIntoView={focused}
            data-test-result
            data-test-search-type={searchType}
        />
    ) : (
        <StyledListItem
            tabIndex={0}
            key={itemId}
            focused={focused}
            onClick={(e) => {
                (e.target as HTMLElement).blur();
                e.stopPropagation();
                e.preventDefault();
                handleOnClick();
            }}
            {...props}
            {...others}
            shouldScrollIntoView={focused}
            data-test-result
            data-test-search-type={searchType}
        />
    );
};
